<template>
  <nuxt-loading-indicator />
  <nuxt-layout>
    <nuxt-page
      :transition="{
        name: 'gportal',
        mode: 'out-in',
        onBeforeEnter,
      }"
    />
  </nuxt-layout>
  <common-svg-icon-gradient />
</template>

<script setup lang="ts">
const { localeProperties, finalizePendingLocaleChange } = useI18n();

const onBeforeEnter = async () => {
  await finalizePendingLocaleChange();
};

useHead({
  htmlAttrs: {
    lang: localeProperties.value.iso,
  },
});

const route = useRoute();
useSeoMeta({
  robots: () => {
    if (Object.keys(route.query).length > 0) {
      return 'noindex';
    }

    return undefined;
  },
});
</script>

<style>
.gportal-enter-active,
.gportal-leave-active {
  transition: opacity 0.2s ease;
}
.gportal-enter-from,
.gportal-leave-to {
  opacity: 0;
}
</style>
